import { render, staticRenderFns } from "./EntradasSinRecintoComponent.vue?vue&type=template&id=7c379a8c"
import script from "./EntradasSinRecintoComponent.vue?vue&type=script&lang=js"
export * from "./EntradasSinRecintoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports